import styled from "styled-components";

export const StyledModalContent = styled.div`
    width: 550px;
    height: 600px;
`;

export const StyledModalScrollableBody = styled.div`
    height: 475px;
    max-height: 475px;
    overflow-y: auto;
    padding: 16px 24px;
    box-sizing: border-box;
`;
